/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React from "react";
import { TableCollum, DialogIcon, InlineLabel, TableBody,  TableRow, TooltipBox, TooltipCard, TooltipText } from "../../flows/quotation/pages/management/styles";
import { FieldArray } from "formik";
import Icon from "components/Icon/index";
import { useHistory, useLocation } from "react-router-dom";
import Colors from "constants/Colors";
import {
  Label,
} from "components/Form";
import { IdColumn, ChildrenRow } from "./styles";
import HasPermission from "components/HasPermission/index";

function PersonAccordion({persons, setPersons, tooltips, getAffectedEnquiries, permissions}) {
  
  const history = useHistory();

  const handleChildVisibility = (parentId, childId, visibility = false) => {
    let parent = persons.find((person) => person.idPerson === parentId);
    if (parent) {
      parent.children = parent.children.map((child) => {
        if (child.idPerson === childId) {
          return {
            ...child,
            showChildRow: visibility
          }
        }
        return child
      })
      setPersons(
        persons.map((person) => {
          if (person.idPerson === parentId) {
            return parent
          }
          return person
        })
      )
    } else {
      const rootPerson = persons.find((person) => person.children.some((p) => p.idPerson === parentId));
      parent = rootPerson.children.find((person) => person.idPerson === parentId);
      parent.children = parent.children.map((child) => {
        if (child.idPerson === childId) {
          return {
            ...child,
            showChildRow: visibility
          }
        }
        return child
      });
      rootPerson.children = rootPerson.children.map((child) => {
        if (child.idPerson === parentId) {
          return parent
        }
        return child
      });
      setPersons(
        persons.map((person) => {
          if (person.idPerson === rootPerson.idPerson) {
            return rootPerson
          }
          return person
        })
      );
    }
  }

  const calculateDepth = (nodes, currentDepth, parentId) => {
    for (const node of nodes) {
      if (node.idPerson === parentId) {
        return currentDepth;
      }
      
      if (node.children.length && node.children.length > 0) {
        const deeperDepth = calculateDepth(node.children, currentDepth + 1, parentId);
        if (deeperDepth) {
          return deeperDepth;
        }
      }
    }

    return null;
  }

  const getDepth = (parentId, children) => {
    let depth = 1;
    const parent = persons.find((person) => person.idPerson === parentId);
    if (parent) {
      return depth;
    }


    const result = calculateDepth(persons, 1, parentId);
    return result || depth;
  };
  const recursiveRenderChildren = (children, parentId) => {
    if (children.length === 0) {
      return;
    }

    const paddingLeft = getDepth(parentId, children) * 20 + 'px';
  
    return children.map((child) => (
      <>
        <ChildrenRow>
          <TableCollum>
            <TooltipCard>
              <InlineLabel>Short Name</InlineLabel>
              <IdColumn paddingLeft={paddingLeft}>
                <div>
                  <DialogIcon>
                    {child.isDisabled
                      ? <Icon name="user-disabled" />
                      : <Icon name="user-able" />}
                  </DialogIcon>
                  <TooltipText>
                    <DialogIcon pink={"exclamation"}>
                      {child.warning ? "!" : ""}
                    </DialogIcon>
                  </TooltipText>
                  <TooltipBox>
                    {tooltips[593]}
                  </TooltipBox>
                  <Label fontSize={12}>
                    <span style={{ color: Colors.GRAY[3] }}>
                      {child.idPerson}
                    </span>
                  </Label>
                </div>
                {
                  child.children.length > 0 && (
                    child.showChildRow ? 
                      <Icon name="arrowup-large" onClick={() => handleChildVisibility(parentId, child.idPerson)} />
                    :
                      <Icon name="arrowdown-large" onClick={() => handleChildVisibility(parentId, child.idPerson, true)} />
                  )
                }
              </IdColumn>
            </TooltipCard>
          </TableCollum>
  
          <TableCollum>
            <InlineLabel>ENTITY</InlineLabel>
            <Label wordWrap fontSize={12}>
              {child.fullName}
            </Label>
          </TableCollum>
          <TableCollum>
            <InlineLabel>Type</InlineLabel>
            <Label wordWrap fontSize={12}>
              {child.hierarchy}
            </Label>
          </TableCollum>
  
          <TableCollum>
            <InlineLabel>Parent</InlineLabel>
            <Label wordWrap fontSize={12}>
              {child.parent}
            </Label>
          </TableCollum>
          <TableCollum>
            <InlineLabel>Holding</InlineLabel>
            <Label wordWrap fontSize={12}>
              {child.holding}
            </Label>
          </TableCollum>
          <TableCollum style={{ textAlign: "right", paddingRight: 10 }}>
            <InlineLabel>Action</InlineLabel>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <HasPermission permission={permissions.MANAGEMENT_ACCESS}>
              {!child.isDisabled ? (
                <>
                  <TooltipCard>
                    <TooltipText>
                      <Icon
                        onClick={() => history.push(`/management/person/${child.idPerson}`)}
                        name="edit"
                        style={{
                          alignSelf: "left",
                          cursor: "pointer",
                        }}
                      />
                    </TooltipText>
                    <TooltipBox>
                      {tooltips[581]}
                    </TooltipBox>
                  </TooltipCard>
                  {child.idPerson === 1 && (
                    <>
                      <Icon
                        onClick={() => history.push(`/products/person/${child.idPerson}`)}
                        name="products"
                        style={{
                          alignSelf: "right",
                          cursor: "pointer",
                        }}
                      />
                      <Icon
                        onClick={() => history.push('/currency/import-rate')}
                        name="currency-rate"
                        style={{
                          alignSelf: "right",
                          cursor: "pointer",
                        }}
                      />
                    </>
                  )}
                  <TooltipCard>
                    <TooltipText>
                      <Icon
                        onClick={() => getAffectedEnquiries(child.idPerson)}
                        name="disable-user"
                        style={{
                          alignSelf: "right",
                          cursor: "pointer",
                        }}
                      />
                    </TooltipText>
                    <TooltipBox>
                      {tooltips[589]}
                    </TooltipBox>
                  </TooltipCard>
                  {child.hierarchy !== 'Individual' && !child.isGovernment && (
                    <TooltipCard>
                      <TooltipText>
                        <Icon
                          onClick={() => history.push(`/product-plan/person/${child.idPerson}`)}
                          name="plan"
                          style={{
                            alignSelf: "right",
                            cursor: "pointer",
                          }}
                        />
                      </TooltipText>
                      <TooltipBox>
                        {tooltips[590]}
                      </TooltipBox>
                    </TooltipCard>
                  )}
                </>
              ) : <></>}
            </HasPermission>
            </div>
          </TableCollum>
        </ChildrenRow>
        {child.children.length > 0 && child.showChildRow ? 
          recursiveRenderChildren(child.children, child.idPerson) 
          : <></>
        }
      </>
    ));
  };
  
return (
  <TableBody>
    <FieldArray
      name="management"
      render={ () =>
        persons.map((item, index) => {
          return (
            <>
              <TableRow key={index}>
              <TableCollum>
                <TooltipCard>
                  <InlineLabel>Short Name</InlineLabel>
                  <IdColumn >
                    <div>
                      <DialogIcon>
                        {item.isDisabled
                          ? <Icon name="user-disabled" />
                          : <Icon name="user-able" />}
                      </DialogIcon>
                      <TooltipText>
                        <DialogIcon pink={"exclamation"}>
                          {item.warning ? "!" : ""}
                        </DialogIcon>
                      </TooltipText>
                      <TooltipBox>
                        {tooltips[593]}
                      </TooltipBox>
                      <Label fontSize={12}>
                        <span style={{ color: Colors.GRAY[3] }}>
                          {item.idPerson}
                        </span>
                      </Label>
                    </div>
                    {
                      item.children.length > 0 && (
                        item.showChildRow ? 
                          <Icon name="arrowup-large" onClick={() => setPersons(persons.map(person => person.idPerson === item.idPerson ? {...person, showChildRow: false} : person))} />
                        :
                          <Icon name="arrowdown-large" onClick={() => setPersons(persons.map(person => person.idPerson === item.idPerson ? {...person, showChildRow: true} : person))} />
                        )
                    }
                  </IdColumn>
                </TooltipCard>
              </TableCollum>

              <TableCollum>
                <InlineLabel>ENTITY</InlineLabel>
                <Label wordWrap fontSize={12}>
                  {item.fullName}
                </Label>
              </TableCollum>

              <TableCollum>
                <InlineLabel>Hierarchy</InlineLabel>
                <Label wordWrap fontSize={12}>
                  {item.hierarchy}
                </Label>
              </TableCollum>

              <TableCollum>
                <InlineLabel>Parent</InlineLabel>
                <Label wordWrap fontSize={12}>
                  {item.parent}
                </Label>
              </TableCollum>

              <TableCollum>
                <InlineLabel>Holding</InlineLabel>
                <Label wordWrap fontSize={12}>
                  {item.holding}
                </Label>
              </TableCollum>

              <TableCollum
                style={{ textAlign: "right", paddingRight: 10 }}
              >
                <InlineLabel>Action</InlineLabel>
                <div style={{ display: 'flex', justifyContent:'flex-end' }}>
                  {!item.isDisabled ?
                        <>
                          <TooltipCard>
                          <TooltipText>
                              <Icon
                                onClick={() =>
                                  history.push(
                                    `/process-admin/person/${item.idPerson}`
                                  )
                                }
                                name="edit"
                                style={{
                                  alignSelf: "left",
                                  cursor: "pointer",
                                }}
                              />
                          </TooltipText>
                          <TooltipBox>
                            {tooltips[581]}
                          </TooltipBox>
                        </TooltipCard>

                      <HasPermission permission={permissions.MANAGEMENT_ACCESS}>
                        {item.idPerson === 1 &&
                          <>
                            <Icon
                              onClick={() => history.push(`/products/person/${item.idPerson}`)}
                              name="products"
                              style={{
                                alignSelf: "right",
                                cursor: "pointer",
                              }}
                            />
                            <Icon
                              onClick={() => history.push('/currency/import-rate')}
                              name="currency-rate"
                              style={{
                                alignSelf: "right",
                                cursor: "pointer",
                              }}
                            />
                          </>
                        }
                        <TooltipCard>
                          <TooltipText>
                            <Icon
                              onClick={() => getAffectedEnquiries(item.idPerson)}
                              name="disable-user"
                              style={{
                                alignSelf: "right",
                                cursor: "pointer",
                              }}
                            />
                          </TooltipText>
                          <TooltipBox>
                            {tooltips[589]}
                          </TooltipBox>
                        </TooltipCard>
                        {(item.hierarchy !== 'Individual' && !item.isGovernment) &&
                          <TooltipCard>
                            <TooltipText>
                              <Icon
                                onClick={() => history.push(`/product-plan/person/${item.idPerson}`)}
                                name="plan"
                                style={{
                                  alignSelf: "right",
                                  cursor: "pointer",
                                }}
                              />
                            </TooltipText>
                            <TooltipBox>
                              {tooltips[590]}
                            </TooltipBox>
                          </TooltipCard>
                        }
                      </HasPermission>
                    </> : <></>}
                </div>
              </TableCollum>
            </TableRow>
            {
              item.children.length > 0 && item.showChildRow ? recursiveRenderChildren(item.children, item.idPerson, 1) : <></>
            }
          </>
          )
        })
      }
    />
  </TableBody>
)
}

export default PersonAccordion;